import useTaboola from "@features/taboola/hooks/useTaboola";

/**
 * Taboola component
 * @returns {React.ReactElement} Taboola component
 */
const Taboola = ({
  pageType,
  container,
  url,
  placement,
}: TaboolaProps): React.ReactElement => {
  useTaboola({ pageType, container, url, placement });

  return <div data-testid="taboola-component" id={container}></div>;
};

export default Taboola;
